<template>
  <div class="chat-form email-box">
    <label class="chat-widget-container" style="margin-left: 4px;">
    </label>

    <table>
      <tr width="100%">
        <td width="100%">
          <input
            v-model.trim="search"
            type="text"
            class="email"
            :placeholder="placeholder"
            clearable
          />
        </td>
        <td width="100%">
          <button :disabled="!search" @click="submit">
            {{ $t(button) }}
          </button>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
const store = require("@/store").default;
import { customLogger } from "@/utils";
export default {
  name: "BoxSearch",
  components: {},
  data: () => {
    return {
      search: "",
      message: (store.state.user.lang === "en" || store.state.config.storeId == 41) ? "While waiting for an agent to become available ..." : "En attendant qu’un agent se libère…",
      placeholder: (store.state.user.lang === "en" || store.state.config.storeId == 41) ? "Enter your search element here" : "Entrez votre élément de recherche ici",
      button: (store.state.user.lang === "en" || store.state.config.storeId == 41) ? "Send" : "Envoyer"
    };
  },
  computed: {},
  mounted() {},
  methods: {
    submit() {
      // customLogger("search : ", store.state.config.storeId);
      let search = this.search;
      if(store.state.config.details.shopify){
        this.$eb.emit("ShopifyFollowOrder", {num:search});
      }
      else {
        this.$eb.emit("GetCommandNumber", search);
      }
      this.search = "";
    },
  },
};
</script>
